import React, { useEffect, useContext } from "react";

import Header from "components/header";
import Footer from "components/footer";
import GlobalBanner from "components/global-banner";
import { AccountContext } from "context/account";
import { CartContext } from "context/cart";
import { useSiteSettings } from "context/site-settings";

import "../styles/global.css";
import "../styles/style.scss";

import useShopifyAnalytics from "../hooks/useShopifyAnalytics";
import { Script } from "gatsby";

const BaseLayout = (props) => {
    const { path, children } = props;
    const settings = useSiteSettings();
    const { fetchCart } = useContext(CartContext);
    const { account: { user, authenticated }, getCustomerProfile, loginUserFromSession } = useContext(AccountContext);

    useShopifyAnalytics();

    useEffect(() => {
        console.log("BaseLayout mounted");
    }, []);

    const getPromoCode = () => {
        if (typeof window !== "undefined") {
            const params = new URLSearchParams(window.location.search);
            return params.get("promo") || "";
        }
        return null;
    }

    useEffect(() => {
        try {
            if (typeof window !== "undefined") {
                const promoCode = getPromoCode();
                if (promoCode && promoCode !== "") localStorage.setItem("discountCode", promoCode);
            }
        } catch (error) {
            console.log(error);
        }
        fetchCart();
    }, []);
    
    useEffect(() => {
        if (!authenticated) loginUserFromSession();
        // If user is authenticated and email is already set, there is no need to call getCustomerProfile
        if (user?.email === undefined || user?.email === "") getCustomerProfile();
    }, []);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const chatWidget = window?.LiveChatWidget;
        if (!chatWidget?.on) return;

        const handler = (event) => {
            console.log('event', event?.visibility);
            if (event?.visibility === "maximized") {
                document.body.classList.add("livechat-maximized");
            } else {
                document.body.classList.remove("livechat-maximized");
            }
        };

        chatWidget.on("visibility_changed", handler);

        // Cleanup
        return () => {
            if (chatWidget?.off) {
                chatWidget.off("visibility_changed", handler);
            }
        };
    }, []);

    return (
        <>
            <Script
                id="paypal-sdk"
                src="https://www.paypal.com/sdk/js?client-id=BAA4AZuEtaNHlL6EEvfQZ2-cPqDTyBY--GLoqUIj5WZl1yZD-1rKaAhKt27xAdmPbq4qQAUGLsEMF0-cgc&components=messages,buttons"
                data-namespace="PayPalSDK"
            />
            <Script id="ps-sdk-loader" src="https://sdk.postscript.io/sdk.bundle.js?shopId=267984" />
            <Script async="" src="//cdn.shopify.com/proxy/18cb73347953000c1e4ec49b6b8cfc1144257c89ce0e20d511103093e4dbf6c2/shopify.livechatinc.com/api/v2/script/d61b77e9-9f0c-44b7-a413-a149d93d8b7b/widget.js?shop=sealskincovers.myshopify.com&amp;sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA" />


            <a
                href="#main"
                className="absolute top-[-40px] left-0 z-50 p-2 bg-gray-900 text-white text-center rounded-md no-underline focus:top-0"
            >
                Skip to content
            </a>
            <Header data={settings?.header} />
            <GlobalBanner globalBannerSettings={settings?.globalBanner} path={path} />
            <main id="main">
                {children}
            </main>
            <Footer data={settings?.footer} />
            <div id="chat-widget-container" />
        </>
    );
};

export default BaseLayout;
